import {
  FZ_CUSTOMER_LIST,
  IS_DRAWER_VISIBLE,
  FZ_FORM_LOADING
} from '../../constants/ActionTypes'

const INIT_STATE = {
  customers:[],
  isDrawerVisible:false,
  loading:false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FZ_CUSTOMER_LIST: {
      return {...state, customers: action.payload};
    }
    case IS_DRAWER_VISIBLE: {
      return {...state, isDrawerVisible: action.payload};
    }
    case FZ_FORM_LOADING: {
      return {...state, loading: action.payload};
    }
    default:
      return state;
  }
}
